import { BASE_SCHEMA_IDS } from '../constants/baseSchemas';
import {
  INSTALL_AGE,
  installAge,
  localDateString,
} from '../containers/FleetStatus/fleetStatusUtils';

// A fridge schema template shares its id with its Location. The schema tools
// should show a schema only when its fridge is active, or when it is a base
// template we deliberately keep visible (base templates have no Location).
//
// In prod, Locations carry only LIVE or OFFLINE; a launching fridge is OFFLINE
// until it opens, so install age (Fleet Status's rule) decides whether an
// OFFLINE fridge is active.
const LAUNCHING_INSTALL_AGES = new Set([INSTALL_AGE.UPCOMING, INSTALL_AGE.NEW]);

export const isActiveFridge = (location, today = localDateString()) => {
  const status = String(location.status).toLowerCase();
  if (status === 'live') {
    return true;
  }
  return (
    status === 'offline' &&
    LAUNCHING_INSTALL_AGES.has(installAge(location.onlineDate, today))
  );
};

export const filterActiveFleet = (locations, today = localDateString()) =>
  (locations || []).filter((loc) => loc.id && isActiveFridge(loc, today));

export const isBaseSchema = (schemaId) => BASE_SCHEMA_IDS.has(schemaId);

export const buildActiveSchemaIdSet = (locations, today = localDateString()) =>
  new Set(filterActiveFleet(locations, today).map((loc) => loc.id));

export const isActiveSchema = (
  schemaId,
  activeSchemaIds,
  { includeBaseSchemas = true } = {},
) =>
  activeSchemaIds.has(schemaId) ||
  (includeBaseSchemas && isBaseSchema(schemaId));

export const filterActiveSchemas = (
  rows,
  activeSchemaIds,
  { includeBaseSchemas = true, schemaIdKey = 'schemaId' } = {},
) =>
  (rows || []).filter((row) =>
    isActiveSchema(row[schemaIdKey], activeSchemaIds, { includeBaseSchemas }),
  );
